import { quoteHasExcludedFromCalculatedMarginTab } from "./marginViewVisibility";

const printedMarginPercent = (value) => {
	if (value == null || String(value).trim() === "") {
		return undefined;
	}
	const numeric = Number(value);
	if (Number.isNaN(numeric)) {
		return String(value).trim();
	}
	return String(Math.round(numeric * 100) / 100);
};

/**
 * When no tab is excluded, non-excluded margins match standard totals (server rule).
 * After bundle paste / partial saves, the client often updates standard recurring fields
 * without refreshing non-excluded — sync in memory for header UI and MLA field reads.
 *
 * Default + Monthly header modes use monthly metrics when DefaultRecurringTermType is Monthly;
 * Annual header uses annual metrics (those tend to stay in sync after paste).
 */
export const hydrateClientNonExcludedMarginsWhenNoExcludedTabs = (quote) => {
	if (!quote || quoteHasExcludedFromCalculatedMarginTab(quote)) {
		return;
	}

	if (quote.GrossMargin != null) {
		quote.NonExcludedGrossMargin = quote.GrossMargin;
		if ("PrintedNonExcludedGrossMargin" in quote) {
			quote.PrintedNonExcludedGrossMargin = printedMarginPercent(quote.GrossMargin);
		}
	}
	if (quote.GrossMarginAmount != null) {
		quote.NonExcludedGrossMarginAmount = quote.GrossMarginAmount;
	}

	if (quote.AnnualRecurringGrossProfit != null) {
		quote.NonExcludedAnnualRecurringGrossProfit = quote.AnnualRecurringGrossProfit;
	}
	if (quote.AnnualRecurringGrossMargin != null) {
		quote.NonExcludedAnnualRecurringGrossMargin = quote.AnnualRecurringGrossMargin;
		if ("PrintedNonExcludedAnnualRecurringGrossMargin" in quote) {
			quote.PrintedNonExcludedAnnualRecurringGrossMargin = printedMarginPercent(
				quote.AnnualRecurringGrossMargin
			);
		}
	}

	if (quote.MonthlyRecurringGrossProfit != null) {
		quote.NonExcludedMonthlyRecurringGrossProfit = quote.MonthlyRecurringGrossProfit;
	}
	if (quote.MonthlyRecurringGrossMargin != null) {
		quote.NonExcludedMonthlyRecurringGrossMargin = quote.MonthlyRecurringGrossMargin;
		if ("PrintedNonExcludedMonthlyRecurringGrossMargin" in quote) {
			quote.PrintedNonExcludedMonthlyRecurringGrossMargin = printedMarginPercent(
				quote.MonthlyRecurringGrossMargin
			);
		}
	}
};
